import React, { useState, useEffect, useCallback, useRef } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { ArrowLeftToLine, ArrowRightToLine } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn } from "lib/utils"
import { CollectionLoader, CkEditor, PlaceholderChooser, Tabset } from "lib/components"
import { useDispute } from "lib/units/dispute/hooks" 
import { useStatements } from "lib/units/dispute/statements"


export default function ContentEditor({ 
  elemtype,
  ctype,
  value="", 
  changeFn, 
  location = "statement"
}: { 
  elemtype:string
  ctype:string
  value:string
  changeFn:any 
  location?:string
}){

  const { dspid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams()
  const [ contentLookup, setContentLookup ] = useState<any>()

  const { data:_Dispute } = queryTools.resource.parseQueryForApi("dispute.findById", { id: dspid }, { enabled: !!dspid })
  const saveFn = queryTools.resource.save(["dispute"])
  
  const { data:_Snippets } = queryTools.resource.parseQueryForApi("content.findAll", { snippet: true })
  // const { data:_Contents } = queryTools.resource.parseQueryForApi("content.findAll", {})
  
  const { updateContentInDispute } = useStatements({ elemtype })
  const { replaceElementConfig } = useDispute({ saveFn })

  
  const [ contentToEdit, setContentToEdit ] = useState<any>()

  const [ sidebarVisible, setSidebarVisible ] = useState<boolean>(true)
  const sidebarTitle = (location === "contentmgr") ? "Content Loader" : "Helpers"
  const tabs = (location === "contentmgr") ? ["Placeholders"] : ["Loader", "Placeholders"]

  const updateEditingContent = (selectedItem:any) => {
    setContentToEdit( (prev:any) => {
      let currentContent = prev || " "
      return `${currentContent}${selectedItem.value || ""}`
    })
  }

  const saveChanges = () => {
    const statementRefStr = searchParams.get("st")
    if( !statementRefStr ) return
    const updatedStatements = updateContentInDispute(_Dispute, statementRefStr, ctype, contentToEdit)
    replaceElementConfig(_Dispute, elemtype, updatedStatements)
  }

  useEffect(() => {
    setContentToEdit(value || " ")
  },[value])

  if( !contentToEdit ) return <></>
  return (
    <div className="w-full h-full flex flex-col">
      <div className="w-full h-full flex items-stretch gap-2 overflow-y-hidden overflow-x-hidden">
        <div className={cn("h-full", sidebarVisible ? "w-9/12" : "w-[calc(100%-3rem)]")}>
          <CkEditor value={contentToEdit} onChange={changeFn} location={location} />
        </div>

        <div className={cn("bg-slate-700 p-[2px]", sidebarVisible ? "w-3/12" : "w-[3rem]",)}> 
          { sidebarVisible === false ? (
            <div 
              className="flex justify-center items-center h-full rotate rotate-90 tracking-[12px] cursor-pointer"
              onClick={() => setSidebarVisible(!sidebarVisible)}
            >
              { sidebarTitle }
            </div>
          ) : (
            <div className="w-full h-full flex flex-col justify-between">
              <Tabset tabs={tabs}>
                <div id="Loader" className="max-h-[500px] overflow-y-auto overflow-x-hidden scrollbar">
                  <CollectionLoader 
                    title="[none]"
                    collection={_Snippets}
                    selectFn={(item:any) => updateEditingContent(item)}
                    selectProp="_id"
                    labelProp="title"
                    className="w-full"
                    showDescriptions={true}
                  />
                </div>
                <div id="Placeholders">
                  <PlaceholderChooser className="" />
                </div>
              </Tabset>
            
            </div>
          )}
        </div>

      </div>

      <div className="w-full h-8 mt-[2px]">
          <button 
            onClick={saveChanges}
            className="w-full h-full bg-teal-700 flex justify-center items-center text-xs uppercase"
          >
            save changes before closing
          </button>
        </div>
    </div>
  )
}